import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import ClassCard from "../components/ClassCard";
import { Lightning } from "@phosphor-icons/react";

export default function Library() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/library").then((r) => setData(r.data)).catch(() => setData({ classes: [], has_subscription: false })); }, []);

  if (!data) return <div className="max-w-6xl mx-auto px-6 py-20 label-overline text-zinc-500" data-testid="loading">Loading…</div>;

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="library-page">
      <span className="label-overline">// Your collection</span>
      <h1 className="font-display text-5xl sm:text-6xl tracking-widest leading-none mt-3 mb-6">Library</h1>

      {data.has_subscription && (
        <div className="border border-[#D4A574]/40 bg-[#D4A574]/5 p-4 flex items-center gap-3 mb-10" data-testid="sub-badge">
          <Lightning weight="fill" className="text-[#D4A574]" /> <span className="label-overline text-[#D4A574]">All-Access Active — every class unlocked</span>
        </div>
      )}

      {data.classes.length === 0 ? (
        <div className="border border-dashed border-white/10 p-16 text-center" data-testid="empty-library">
          <p className="label-overline text-zinc-500">You haven't unlocked any classes yet</p>
          <Link to="/classes" className="kinetic-btn mt-6 inline-block">Browse Classes</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="library-grid">
          {data.classes.map((c) => <ClassCard key={c.id} cls={c} />)}
        </div>
      )}
    </div>
  );
}
